/**
 * Centralized mock data for local development
 * All API responses are defined here
 */

const mockData = {
  // Account Info mock data
  accountInfo: {
    firstName: "CUES",
    lastName: "Team",
    fullName: "CUES Team",
    employer: "CUES Staff",
    position: "VP/Membership",
    membershipLevel: "MVP Unlimited+",
    memberId: "1000157",
    acgiRole: "Executive",
    countryCode: "USA",
    cmanPersonas: "Executive",
    cuesPersonas: "Executive",
    hasNovoEdCourseData: true
  },

  // Layout mock data
  layout: [
    "cmp_benefits",
    "cmp_my_cues_learning",
    "cmp_events",
    "cmp_cu_management",
    "cmp_cues_net"
  ],

  // Benefits mock data
  benefits: {
    keyBenefits: [
      {
        title: "CU Management Magazine",
        description: "The latest CU news in print and digital - with articles covering all aspects of financial services.",
        image: "https://stage.cues.org/sites/default/files/2024-09/dashboard-tile-cumgmt.png",
        link: "https://www.cues.org/cumanagement-external",
        file: null,
        linkType: "external_link",
        contact: null
      },
      {
        title: "CUES Learning Portal",
        description: "Easily expand your skillset in any soft skill or leadership topic you can imagine with CUES Learning Portal, where you'll find access to top-notch courses and engaging Learning Journeys.",
        image: "https://stage.cues.org/sites/default/files/2024-09/dashboard-tile-clp.png",
        link: "internal:#cueslearning",
        file: null,
        linkType: "external_link",
        contact: null
      },
      {
        title: "CUESNet",
        description: "An online networking tool connecting you with other CUES members. Join communities and get in on the conversation today!",
        image: "https://stage.cues.org/sites/default/files/2024-09/dashboard-tile-cuesnet.png",
        link: "https://cuesnet.cues.org/home",
        file: null,
        linkType: "external_link",
        contact: null
      },
      {
        title: "Harvard ManageMentor",
        description: "Explore this suite of more than 40 online courses from Harvard Business Review.",
        image: "https://stage.cues.org/sites/default/files/2022-08/logo-benefits-harvard_0.png",
        link: "https://cues.myhbp.org/hmm12/home.html",
        file: null,
        linkType: "external_link",
        contact: null
      }
    ],
    allBenefits: [
      {
        title: "CU Management Magazine",
        description: "The latest CU news in print and digital - with articles covering all aspects of financial services.",
        image: "https://stage.cues.org/sites/default/files/2024-09/dashboard-tile-cumgmt.png",
        link: "https://www.cues.org/cumanagement-external",
        file: null,
        linkType: "external_link",
        contact: null
      },
      {
        title: "CUES Councils",
        description: "Learn directly from industry experts while connecting with peers at these in-person regional networking events.",
        image: "https://stage.cues.org/sites/default/files/2024-09/dashboard-tile-councils.png",
        link: "https://cues.org/Councils",
        file: null,
        linkType: "external_link",
        contact: null
      },
      {
        title: "CUES Learning Portal",
        description: "Easily expand your skillset in any soft skill or leadership topic you can imagine.",
        image: "https://stage.cues.org/sites/default/files/2024-09/dashboard-tile-clp.png",
        link: "internal:#cueslearning",
        file: null,
        linkType: "external_link",
        contact: null
      }
    ],
    resources: [
      {
        title: "CUES Leadership Development Guide",
        description: "Learn the keys to building a strong leadership pipeline with this guide.",
        image: "https://stage.cues.org/sites/default/files/2024-09/icon-leadership-43x30px.png",
        file: null,
        link: "https://hubs.la/Q01Y4cHQ0",
        linkType: "external_link",
        contact: null
      },
      {
        title: "Welcome to Credit Union Leadership Guide",
        description: "New to the CU movement? Download this guide for executives who are new to the industry.",
        image: "https://stage.cues.org/sites/default/files/2024-09/icon-welcome-43x30px.png",
        file: null,
        link: "https://hubs.la/Q01Y4dgF0",
        linkType: "external_link",
        contact: null
      }
    ]
  },

  // Events mock data
  events: {
    events: {
      withMembership: [
        {
          title: "Virtual Classroom: Leadership Development",
          image: "https://cues.org/sites/default/files/2022-06/22_Aug16-VC_Event-Image_1280x550%20%281%29.jpg",
          startDate: "2025-03-14",
          endDate: "2025-03-14",
          date: "March 14, 2025",
          eventType: "Online Event",
          eventLocation: null,
          registrationLink: "https://cues.org/register",
          eventDetailsLink: "https://cues.org/event-details",
          eventRoles: ["CEO", "Executive"],
          destinationUrl: null,
          eventId: "event-001",
          eventNodeId: "node-001"
        }
      ],
      purchase: [],
      registered: []
    }
  },

  // Articles mock data
  articles: [
    {
      id: "53051",
      title: "Dedicated to Helping Others",
      image: "https://www.cumanagement.com/sites/default/files/styles/panel_image/public/2025-03/3.5%20CUES%20DD%20Award%20Winner.jpg",
      date: "Mar 05, 2025",
      type: "Article",
      author: "Diane Franklin",
      url: "https://www.cumanagement.com/articles/2025/03/dedicated-helping-others",
      length: "10 minutes",
      roles: ["CEO", "Executive", "Board"]
    },
    {
      id: "53031",
      title: "Stepping Aside to Move Forward",
      image: "https://www.cumanagement.com/sites/default/files/styles/panel_image/public/2025-02/2.27%20Pixie%20Stepping%20Aside%20to%20Move%20Forward.jpg",
      date: "Feb 27, 2025",
      type: "Article",
      author: "Pixie Gray",
      url: "https://www.cumanagement.com/articles/2025/02/stepping-aside-move-forward",
      length: "5 minutes",
      roles: ["CEO", "Executive"]
    }
  ],

  // NovoEd/Learning mock data
  novoed: {
    learning: {
      enrolled: [
        {
          name: "Leadership Essentials",
          type: "Course",
          course_id: "course-001",
          catalog_id: "cat-001",
          class_summary: "Develop your leadership skills with this comprehensive course.",
          course_url: "https://cues.novoed.com/course/001",
          completion_progress: "in_progress",
          last_activity: "2025-01-15",
          order_date: "2025-01-01",
          drupal_values: {
            topics: "Leadership",
            personas: "Executive",
            tier: "Unlimited",
            series: null,
            learning_journeys: null
          }
        },
        {
          name: "Emotional Intelligence Fundamentals",
          type: "Course",
          course_id: "course-003",
          catalog_id: "cat-003",
          class_summary: "Master the basics of emotional intelligence in the workplace.",
          course_url: "https://cues.novoed.com/course/003",
          completion_progress: "enrolled",
          last_activity: null,
          order_date: "2025-01-10",
          drupal_values: {
            topics: "Emotional Intelligence",
            personas: "Executive",
            tier: "Unlimited",
            series: null,
            learning_journeys: null
          }
        },
        {
          name: "Applied Leadership Journey",
          type: "Journey",
          id: "journey-enrolled-001",
          catalog_id: "cat-journey-enrolled-001",
          class_summary: "A hands-on learning journey combining leadership theory with practical application.",
          course_url: "https://cues.novoed.com/journey/enrolled-001",
          novoEdStatus: "in_progress",
          order_date: "2024-12-20",
          drupal_values: {
            topics: "Leadership",
            personas: "Executive",
            tier: "Unlimited"
          }
        }
      ],
      completed: [
        {
          name: "Strategic Planning 101",
          type: "Course",
          course_id: "course-002",
          catalog_id: "cat-002",
          class_summary: "Learn strategic planning fundamentals.",
          course_url: "https://cues.novoed.com/course/002",
          completion_progress: "completed",
          completed_at: "2024-12-15",
          close_date: null,
          drupal_values: {
            topics: "Strategy",
            personas: "Executive",
            tier: "Unlimited"
          }
        },
        {
          name: "Emotional Resilience Training",
          type: "Course",
          course_id: "course-004",
          catalog_id: "cat-004",
          class_summary: "Build emotional resilience to handle workplace stress and challenges.",
          course_url: "https://cues.novoed.com/course/004",
          completion_progress: "completed",
          completed_at: "2024-11-30",
          close_date: null,
          drupal_values: {
            topics: "Emotional Intelligence",
            personas: "Executive",
            tier: "Unlimited"
          }
        }
      ],
      learning_journeys: [
        {
          id: "journey-001",
          name: "Executive Leadership Journey",
          type: "Journey",
          catalog_id: "cat-journey-001",
          class_summary: "A comprehensive learning journey for executive leaders.",
          course_url: "https://cues.novoed.com/journey/001",
          novoEdStatus: "available",
          drupal_values: {
            topics: "Leadership",
            personas: "Executive",
            tier: "Unlimited"
          }
        },
        {
          id: "journey-002",
          name: "Emotional Intelligence Mastery",
          type: "Journey",
          catalog_id: "cat-journey-002",
          class_summary: "Complete mastery of emotional intelligence across all dimensions.",
          course_url: "https://cues.novoed.com/journey/002",
          novoEdStatus: "available",
          drupal_values: {
            topics: "Emotional Intelligence",
            personas: "Executive",
            tier: "Unlimited"
          }
        }
      ]
    }
  },

  // Recommendations mock data
  recommendations: {
    user_id: "user-001",
    recommendations: [
      {
        item_id: "rec-001",
        course_id: "course-rec-001",
        recommendation_id: "recommendation-001",
        topics: "Leadership",
        personas: "Executive",
        tiers: "Unlimited",
        series: null,
        learning_journeys: null,
        course_record: {
          name: "Advanced Leadership Strategies",
          type: "Course",
          catalog_id: "cat-rec-001",
          class_summary: "Take your leadership skills to the next level with advanced strategies.",
          course_url: "https://cues.novoed.com/course/rec-001"
        }
      },
      {
        item_id: "rec-002",
        course_id: "course-rec-002",
        recommendation_id: "recommendation-002",
        topics: "Management",
        personas: "Manager",
        tiers: "Unlimited",
        series: null,
        learning_journeys: null,
        course_record: {
          name: "Effective Team Management",
          type: "Course",
          catalog_id: "cat-rec-002",
          class_summary: "Learn how to build and manage high-performing teams.",
          course_url: "https://cues.novoed.com/course/rec-002"
        }
      },
      {
        item_id: "rec-003",
        course_id: "course-rec-003",
        recommendation_id: "recommendation-003",
        topics: "Emotional Intelligence",
        personas: "Executive",
        tiers: "Unlimited",
        series: null,
        learning_journeys: null,
        course_record: {
          name: "Enhancing Emotional Intelligence",
          type: "Course",
          catalog_id: "cat-rec-003",
          class_summary: "Explore the critical role of emotional intelligence in the workplace and its impact on individual and team performance.",
          course_url: "https://cues.novoed.com/course/rec-003"
        }
      },
      {
        item_id: "rec-004",
        course_id: "course-rec-004",
        recommendation_id: "recommendation-004",
        topics: "Emotional Intelligence",
        personas: "Manager",
        tiers: "Unlimited",
        series: null,
        learning_journeys: null,
        course_record: {
          name: "Emotional Intelligence for Leaders",
          type: "Course",
          catalog_id: "cat-rec-004",
          class_summary: "Develop emotional intelligence competencies essential for effective leadership and decision-making.",
          course_url: "https://cues.novoed.com/course/rec-004"
        }
      },
      {
        item_id: "rec-005",
        course_id: "course-rec-005",
        recommendation_id: "recommendation-005",
        topics: "Communication",
        personas: "Executive",
        tiers: "Unlimited",
        series: null,
        learning_journeys: null,
        course_record: {
          name: "Emotional Resilience in the Workplace",
          type: "Course",
          catalog_id: "cat-rec-005",
          class_summary: "Build emotional resilience to navigate workplace challenges and maintain peak performance under pressure.",
          course_url: "https://cues.novoed.com/course/rec-005"
        }
      },
      {
        item_id: "rec-006",
        course_id: "course-rec-006",
        recommendation_id: "recommendation-006",
        topics: "Strategy",
        personas: "Executive",
        tiers: "Unlimited",
        series: null,
        learning_journeys: null,
        course_record: {
          name: "Strategic Emotional Leadership",
          type: "Course",
          catalog_id: "cat-rec-006",
          class_summary: "Combine strategic thinking with emotional awareness to lead organizations through complex change.",
          course_url: "https://cues.novoed.com/course/rec-006"
        }
      },
      {
        item_id: "rec-007",
        course_id: "course-rec-007",
        recommendation_id: "recommendation-007",
        topics: "Innovation",
        personas: "Executive",
        tiers: "Unlimited",
        series: null,
        learning_journeys: null,
        course_record: {
          name: "Emotional Intelligence and Innovation",
          type: "Course",
          catalog_id: "cat-rec-007",
          class_summary: "Discover how emotional intelligence drives innovation and creative problem-solving in organizations.",
          course_url: "https://cues.novoed.com/course/rec-007"
        }
      },
      {
        item_id: "rec-008",
        course_id: "course-rec-008",
        recommendation_id: "recommendation-008",
        topics: "Leadership",
        personas: "Executive",
        tiers: "Unlimited",
        series: null,
        learning_journeys: null,
        course_record: {
          name: "Emotional Intelligence in Conflict Resolution",
          type: "Course",
          catalog_id: "cat-rec-008",
          class_summary: "Apply emotional intelligence techniques to resolve workplace conflicts and build stronger team relationships.",
          course_url: "https://cues.novoed.com/course/rec-008"
        }
      },
      {
        item_id: "rec-009",
        course_id: "course-rec-009",
        recommendation_id: "recommendation-009",
        topics: "Leadership",
        personas: "Executive",
        tiers: "Unlimited",
        series: null,
        learning_journeys: null,
        course_record: {
          name: "Emotional Agility for Executives",
          type: "Course",
          catalog_id: "cat-rec-009",
          class_summary: "Master emotional agility to adapt quickly to changing business environments and lead with confidence.",
          course_url: "https://cues.novoed.com/course/rec-009"
        }
      },
      {
        item_id: "rec-010",
        course_id: "course-rec-010",
        recommendation_id: "recommendation-010",
        topics: "Culture",
        personas: "Executive",
        tiers: "Unlimited",
        series: null,
        learning_journeys: null,
        course_record: {
          name: "Building Emotional Culture",
          type: "Course",
          catalog_id: "cat-rec-010",
          class_summary: "Learn to create an emotionally intelligent organizational culture that attracts and retains top talent.",
          course_url: "https://cues.novoed.com/course/rec-010"
        }
      }
    ]
  },

  // Sponsorship Opportunities mock data
  sponsorshipOpportunities: {
    data: [
      {
        title: "Annual Conference Sponsorship",
        description: "Premier sponsorship opportunity at our flagship annual conference.",
        date: "2025-06-15",
        eventLocation: "In-Person Event",
        image: "https://cues.org/sites/default/files/event-image.jpg",
        url: "https://cues.org/sponsorship/annual-conference",
        roles: ["CEO", "Executive"],
        eventId: "sponsor-001",
        eventNodeId: "node-sponsor-001"
      }
    ],
    message: "1 sponsorship opportunity found."
  }
};

export default mockData;
